import React, { useState } from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";

import { MDBBtn, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { LondonDate } from "../../Utils/utils";
import { useEffect } from "react";

export const BulkActions = {
    Delete: {action: 'delete', label: 'Delete', type: ''},
    Activate: {action: 'activate', label: 'Make Active', type: ''},
    Deactivate: {action: 'deactivate', label: 'Make Inactive', type: ''},
    StartDate: {action: 'set_startdate', label: 'Adjust Start Date/Time', type: 'date'},
    EndDate: {action: 'set_enddate', label: 'Adjust End Date/Time', type: 'date'},
    DwellTime: {action: 'set_dwelltime', label: 'Adjust Dwell Time', type: 'number'},
    TriggerQty: {action: 'set_trigger_qty', label: 'Adjust Trigger Qty', type: 'number'},
    IncentiveQty: {action: 'set_incentive_qty', label: 'Adjust Incentive Qty', type: 'number'},
    PagePosition: {action: 'set_page_position', label: 'Adjust Page Position', type: 'number'}
}

const BulkActionPanel = React.memo(props=>{
    const [bulkActionOpts, setBulkActionOpts] = useState([]);
    const [bulkData, setBulkData] = useState({
        action: '',
        value: '',
        type: '',
    });

    useEffect(()=>{
        setBulkActionOpts(props.bulkActions.map(act=>({
            value: act.action,
            label: act.label,
            type: act.type,
        })));
    }, [props.bulkActions])

    const onBulkActionChanged = (opt) => {
        let v = '';
        const now = LondonDate(new Date());
        switch(opt.value) {
            case BulkActions.StartDate.action:
                v = LondonDate(new Date(`${now.year()}-${now.month()+1}-${now.date()} 00:00:00`));
                break;
            case BulkActions.EndDate.action:
                v = LondonDate(new Date(`${now.year()}-${now.month()+1}-${now.date()} 23:59:59`));
                break;
            case BulkActions.DwellTime.action:
                v = 3;
                break;
        }
        setBulkData({
            action: opt.value,
            value: v,
            type: opt.type
        });
    }
    const handleDateChange = (d) => {
        setBulkData({
            ...bulkData,
            value: d
        })
    }
    const handleTextChange = (e) => {
        setBulkData({
            ...bulkData,
            value: e.target.value
        })
    }
    const handleBulkAction = () => {
        props.handleBulkAction && props.handleBulkAction(bulkData);
    }

    return (
    <div className="d-flex align-items-center">
        <label className="me-2">Bulk Actions</label>
        <div style={{width:250}}>
            <Select options={bulkActionOpts} onChange={onBulkActionChanged} value={bulkActionOpts?.find(opt => opt.value === bulkData.action)} />
        </div>
        {(() => {
            switch(bulkData.type) {
                case 'date':
                    return (
                        <div className="ms-2">
                            <DateTimePicker onChange={d=>handleDateChange(d)} value={bulkData.value} format="y/MM/dd HH:mm:ss" disableClock={true} />
                        </div>
                    )
                case 'number':
                    return (
                        <div className="ms-2" style={{width: 150}}>
                            <MDBInput className="text-center" onChange={handleTextChange} value={bulkData.dwell_time} type="number" />
                        </div>
                    )
                case 'text':
                    return (
                        <div className="ms-2" style={{width: 150}}>
                            <MDBInput className="text-center" onChange={handleTextChange} value={bulkData.dwell_time} type="text" />
                        </div>
                    )
            }
        })()}

        <MDBBtn className="ms-2" color="danger" onClick={handleBulkAction} disabled={props.bulkActioning}>
            {props.bulkActioning && <MDBSpinner size="sm" />}
            <span className="ms-1">Apply Bulk Changes</span>
        </MDBBtn>
    </div>
    )
});

export default BulkActionPanel;